<template>
  <v-dialog persistent v-model="dialog" width="700" scrollable>
    <v-card v-if="dialog">
      <v-card-title>CNPJ/CPF já cadastrado</v-card-title>
      <v-card-text>
        <p>
          Já existem cadastros com este CNPJ/CPF. Você deve escolher se deseja
          continuar com o novo cadastro ou atualizar um cadastro já existente
          (clique na lista para abrir o cadastro em nova aba).
        </p>
        <v-list>
          <v-list-item
            v-for="(cliente, i) in existentes"
            :key="`cliente-${i}`"
            class="px-0"
            :to="{
              name: 'cliente-formulario-editar',
              params: { id: cliente.id },
            }"
            target="_blank"
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                {{ cliente.tipo == "J" ? "CNPJ" : "CPF" }}:
                {{ mascara(cliente) }} {{ cliente.nome }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                Representante: {{ cliente.vendedor.nome }}
              </v-list-item-subtitle>
              <v-list-item-title>
                {{ cliente.razao_social }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn depressed @click="$emit('voltar')">
          <v-icon left>mdi-arrow-left</v-icon>
          Voltar à lista de clientes
        </v-btn>
        <dialog-confirm
          titulo="Confirmação"
          texto="Tem certeza que deseja prosseguir com a criação de um novo cadastro com este CNPJ/CPF?"
          @confirmar="$emit('continuar')"
        >
          <v-btn color="error" depressed class="ml-2">
            <v-icon left>mdi-alert-outline</v-icon>
            CRIAR NOVO CADASTRO
          </v-btn>
        </dialog-confirm>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogConfirm from "../DialogConfirm";
import { build } from "../../lib/masks";
export default {
  components: { DialogConfirm },
  props: ["existentes"],
  computed: {
    dialog: {
      get() {
        return this.existentes.length > 0;
      },
      set(dialog) {
        if (!dialog) {
          this.$emit("continuar");
        }
      },
    },
  },
  methods: {
    mascara(cliente) {
      if (cliente.tipo == "J") {
        return build.cnpj(cliente.cpf_cnpj);
      }
      return build.cpf(cliente.cpf_cnpj);
    },
  },
};
</script>
